import { render, staticRenderFns } from "./ExtrRec.vue?vue&type=template&id=90f7b3f2&lang=pug&"
import script from "./ExtrRec.vue?vue&type=script&lang=js&"
export * from "./ExtrRec.vue?vue&type=script&lang=js&"
import style0 from "./ExtrRec.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports